import React from "react";

export default function Break() {
  return <div style={{ height: 1, background: "#BFBFBF", width: "100%" }} />;
}
